import Vue from 'vue'
import get from 'lodash/get'

const getValue = (value = {}, opt = '') => {
  const result = get(value, opt)
  return result || ''
}

Vue.filter('get', getValue)
